/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ThreeDS
 */
export interface ThreeDS {
    /**
     * 3DS Exemption Request
     * Possible value
     * <ul><li>NO_PREFERENCE: The issuing Bank can choose to activate or not 3DS v2</li></ul>
     * @type {string}
     * @memberof ThreeDS
     */
    threeDSModeRequested?: string;
    /**
     * 3DS Authentication Result
     * Possible values:
     * <ul><li>CHALLENGE: 3DS v2 was activated and the card owner was asked to be strongly authenticated</li><li>FRICTIONLESS: 3DS v2 was not activated</li><li>NONE: We could not get the SCA result</li></ul>
     * @type {string}
     * @memberof ThreeDS
     */
    threeDSResult?: string;
}

/**
 * Check if a given object implements the ThreeDS interface.
 */
export function instanceOfThreeDS(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ThreeDSFromJSON(json: any): ThreeDS {
    return ThreeDSFromJSONTyped(json, false);
}

export function ThreeDSFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThreeDS {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'threeDSModeRequested': !exists(json, 'threeDSModeRequested') ? undefined : json['threeDSModeRequested'],
        'threeDSResult': !exists(json, 'threeDSResult') ? undefined : json['threeDSResult'],
    };
}

export function ThreeDSToJSON(value?: ThreeDS | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'threeDSModeRequested': value.threeDSModeRequested,
        'threeDSResult': value.threeDSResult,
    };
}

